module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAk4AAAGQAQMAAABiS310AAAAA1BMVEVNo/93ECPuAAAANElEQVR42u3BMQEAAADCIPuntsROYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkQN1MAABCO71SAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/xh_qyjs.png
// module id = mfA2
// module chunks = 0